import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import Icon from './icon'
import TopTooltip from './topTooltip'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map } from 'immutable'

/**
 * Flag record
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class FlagRecordModal extends React.Component {
  static propTypes = {
    recordId: React.PropTypes.string.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      showModal: false,
      data: Map(),
      link: createLinkToImmutable(this, 'data')
    }
  }

  showWindow () {
    this.setState({ showModal: true })
  }

  hideWindow () {
    this.setState({
      showModal: false,
      data: Map(),
      link: createLinkToImmutable(this, 'data')
    })
  }

  async flag (evt) {
    evt.preventDefault()

    const { recordId } = this.props
    const { store } = this.context
    const { data } = this.state

    try {
      await store.post(`/records/${recordId}/flag`, data)
      this.hideWindow()
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { data, showModal, link } = this.state

    return (
      <span>
        <TopTooltip content="Flag data inaccuracy">
          <Button
            bsStyle="link"
            onClick={::this.showWindow}>
            <Icon name ="fa-flag" />
          </Button>
        </TopTooltip>

        <Modal show={showModal} onHide={::this.hideWindow}>
          <Modal.Header closeButton>
            <h4 className="modal-title">Flag this record as inaccurate?</h4>
          </Modal.Header>

          <Modal.Body>
            <p>Please give a detailed description of what is inaccurate:</p>
            <Input
              autoFocus
              type="textarea"
              valueLink={link('reason')}
              name="reason" />
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              bsStyle="danger"
              disabled={!data.get('reason')}
              onClick={::this.flag}>
              Yes, flag this record
            </Button>
          </Modal.Footer>
        </Modal>
      </span>
    )
  }
}

export default FlagRecordModal



// WEBPACK FOOTER //
// ./modules/shared/components/flagRecordModal.js